import _objectSpread from "E:\\workspace\\\u6C9B\u57CE\\pcweb\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.search";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import packageTableMixins from "@/mixins/packageTableMixins";
import customDetails from "./components/customDetails.vue";
import uploadCom from "./components/uploadCom";
import addCom from "./components/addCom";
import passCom from "./components/passCom";
import config from "@/config/index";
import { product_list, set_default as _set_default, product_add, dict_update, product_del, daoru as _daoru, daochu, get_type as _get_type, get_downloadtoken, config_pass } from "@/api/jingxiaoshang";
export default {
  name: "MechanismManage",
  mixins: [packageTableMixins],
  data: function data() {
    var _this2 = this;

    return {
      pass_priv: 1,
      xieyiData: [{
        value: -1,
        name: this.$t("全部")
      }, {
        value: 1,
        name: this.$t("默认")
      }, {
        value: 2,
        name: this.$t("自定义")
      }],
      xieyi_codeData: [],
      product_type_codeData: [],
      model_codeData: [],
      country_codeData: [{
        value: "xciot-prod-cnsz",
        name: "中国区"
      }, {
        value: "xciot-prod-hk",
        name: "香港区"
      }, {
        value: "xciot-prod-eu",
        name: "欧洲区"
      }, {
        value: "xciot-prod-us2",
        name: "美国区"
      }],
      country_code2Data: [{
        value: "86",
        name: "中国"
      }],
      form_filter: {
        xieyi_type: "",
        product_type_code: "",
        project_code: ""
      },
      //共用的查询与重置
      topButtonList: [{
        name: this.$t('query'),
        type: "primary",
        method: this.search
      }, {
        name: this.$t('reset'),
        type: "error",
        method: this.reset
      }],
      //共用的右侧添加按钮
      topButtonList1: [{
        name: this.$t("add"),
        icon: "ios-add",
        type: "primary",
        method: this.add
      }],
      reqBase: {
        page: 1,
        page_size: 15,
        product_type_code: this.$route.query.product_type_code,
        hardware_ver: this.$route.query.hardware_ver
      },
      status: true,
      //是否企业认证
      tableDataList: [],
      getPageTotal: 0,
      operationButtonList: [{
        name: this.$t("delete"),
        type: "primary",
        icon: "",
        method: this.del
      }, {
        name: this.$t("devicelist.passman"),
        type: "primary",
        icon: "",
        method: this.configpass
      }],
      customButtonList: [{
        name: this.$t("自定义") + '>',
        type: "text",
        icon: "",
        method: this.custom
      }],
      // operationButtonList1:[
      //   {
      //     name:this.$t('operationModule.submitReview'),
      //     type:'primary',
      //     icon:'',
      //     method:this.submitReview
      //   },
      // ],
      columnsheader: [// {
      //   align: 'center',
      //   title: '序号',//this.$t('dictmenu.protocoltype')
      //   key: 'id',
      // },
      {
        align: "center",
        title: this.$t("产品项目号"),
        key: "project_code"
      }, {
        align: "center",
        title: this.$t("产品名称"),
        key: "product_name"
      }, {
        align: "center",
        title: this.$t("devicelist.hardwareversionnumber"),
        key: "hardware_ver"
      }, {
        align: "center",
        title: this.$t("产品型号"),
        key: "model_code"
      }, // {
      //   align: 'center',
      //   title: '联网方式',
      //   key: 'connect_type',
      //   render:(h,{row})=>{
      //         let result = '';
      //        if (row.connect_type == 1) {
      //           result="WiFi"
      //        } else if(row.connect_type == 2) {
      //           result="4G"
      //        }else{
      //         result=""
      //        }
      //         return h('div',result)
      //   }
      // },
      {
        align: "center",
        title: this.$t("协议配置"),
        key: "xieyi_type",
        render: function render(h, _ref) {
          var row = _ref.row;

          if (row.xieyi_type == 1) {
            var _result = "";
            _result = _this2.$t("默认");
            return h("div", _result);
          } else if (row.xieyi_type == 2) {
            var arr = [];
            var list = _this2.customButtonList[0];
            arr.push(h("Button", {
              style: {
                marginLeft: "5px",
                marginBottom: "3px",
                color: "#3253fa"
              },
              props: {
                type: list.type,
                size: list.size ? list.size : "small"
              },
              on: {
                click: function click() {
                  _this2.custom(row);
                }
              }
            }, list.name));
            return h("div", {
              style: {
                padding: "5px"
              }
            }, arr);
          } else {
            result = "";
            return h("div", result);
          }
        }
      }, {
        align: "center",
        title: this.$t("dictmenu.creationtime"),
        key: "addtime"
      }, {
        align: "center",
        title: this.$t("handleuser"),
        key: "admin_name"
      }, {
        align: "center",
        title: this.$t("operation"),
        minWidth: 80,
        key: "Operating",
        render: function render(h, _ref2) {
          var row = _ref2.row;
          var arr = []; //this.operationButtonList = [];

          var list = _this2.operationButtonList[0];
          arr.push(h("Button", {
            style: {
              marginLeft: "5px",
              marginBottom: "3px"
            },
            props: {
              type: list.type,
              size: list.size ? list.size : "small"
            },
            on: {
              click: function click() {
                _this2.del(row);
              }
            }
          }, list.name));

          if (_this2.pass_priv == 1) {
            list = _this2.operationButtonList[1];
            arr.push(h("Button", {
              style: {
                marginLeft: "5px",
                marginBottom: "3px"
              },
              props: {
                type: list.type,
                size: list.size ? list.size : "small"
              },
              on: {
                click: function click() {
                  _this2.configpass(row);
                }
              }
            }, list.name));
          }

          return h("div", {
            style: {
              padding: "5px"
            }
          }, arr); // return h('div',arr)
        }
      }]
    };
  },
  props: {
    reducehe: {},
    code: {}
  },
  components: {
    customDetails: customDetails
  },
  computed: {},
  methods: {
    custom: function custom(row) {
      var routeData = this.$router.push({
        path: "/protocolman/projectprotocollist",
        query: {
          product_code: row.product_code,
          project_code: row.project_code,
          xieyi_code: row.xieyi_code
        }
      });
      window.open(routeData.href, "_self");
    },
    get_type: function get_type() {
      var _this3 = this;

      _get_type({}).then(function (res) {
        var msg = res.errorMsg;

        if (res.result === 0) {
          var _msg = res.errorMsg;
          _this3.product_type_codeData = res.body.product_type;
          _this3.xieyi_codeData = res.body.xieyi_codeData;
          _this3.model_codeData = res.body.model_codeData;
          console.log("111", _this3.xieyi_codeData); //this.inverter_typeData=res.body.inverter_type
        } else {
          vm.$Message.error(msg);
          _this.buttonLoading = false;
        }
      });
    },

    /**
     * 导入
     */
    daoru: function daoru() {
      var _this4 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("h3", _this4.$t("import")), h(uploadCom, {
            ref: "uploadCom",
            props: {
              edit: false,
              _vm: vm
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.uploadCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //提交请求
              var formModel = obj.formModel;
              var formData = new FormData();
              formData.append("filename", formModel.filename);

              _daoru(formData).then(function (res) {
                if (res.result === 0) {
                  vm.$Message.success(res.errorMsg);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(res.errorMsg, 5);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    daochu: function daochu() {
      var vm = this;
      var config = {
        title: this.$t("export"),
        loading: true,
        content: this.$t("dictmenu.sureexport"),
        onOk: function onOk() {
          var _this = this; // vm.$store.dispatch("user/handleget_downloadtoken", { type: "did" })
          //   .then((res) => {


          get_downloadtoken().then(function (res) {
            // console.log(res.result)
            //     return
            _this.buttonLoading = false;

            if (res.result === 0) {
              var downloadtoken = res.body.downloadtoken;
              var params = "?type=1&downloadtoken=" + downloadtoken;
              window.open("http://pcphp.test.xcthings.com/index.php/admin/dict/daochu" + params);
              vm.$Modal.remove();
            } else {
              vm.$Message.error(res.errorMsg);
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },

    /**
     * 删除
     */
    del: function del(row) {
      var vm = this;
      this.$Modal.confirm({
        title: this.$t('删除'),
        content: this.$t('您确定要删除') + row.project_code + '?',
        loading: true,
        onOk: function onOk() {
          var _this = this;

          product_del({
            product_code: row.product_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg2 = res.errorMsg;
              vm.$Message.success(_msg2);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    details: function details(row) {
      var _this5 = this;

      var vm = this;
      var config = {
        okText: "关闭",
        loading: true,
        width: 600,
        render: function render(h) {
          return h("div", [h("h3", _this5.$t("viewdetails")), h(addCom, {
            ref: "addCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              hasDetails: true,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          this.$Modal.remove();
        }
      };
      this.$Modal.success(config);
    },
    configpass: function configpass(row) {
      var _this6 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this6.$t("Changelang.密码管理")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(passCom, {
            ref: "passCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: true,
              parent_code: "0",
              parent_name: "无",
              product_type_codeData: vm.product_type_codeData,
              setData: row
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.passCom;
          obj.checkForm().then(function (res) {
            // console.log("req", {...obj.formModel})
            // return;
            if (res) {
              config_pass(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg3 = res.errorMsg;
                  vm.$Message.success(_msg3);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    getUser: function getUser() {
      return this.$store.state.user.userInfo;
    },
    add: function add() {
      var _this7 = this;

      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this7.$t("新建产品（产品模型）")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(addCom, {
            ref: "addCom",
            props: {
              _vm: vm,
              $store: vm.$store,
              edit: false,
              parent_code: "0",
              parent_name: "无",
              product_type_codeData: vm.product_type_codeData,
              xieyi_codeData: vm.xieyi_codeData,
              product_type_code: vm.$route.query.product_type_code,
              hardware_ver: vm.$route.query.hardware_ver,
              model_codeData: vm.model_codeData
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            // console.log("req", obj)
            // return;
            if (res) {
              product_add(_objectSpread({}, obj.formModel)).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg4 = res.errorMsg;
                  vm.$Message.success(_msg4);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    edit: function edit(row) {
      var _this8 = this;

      console.log("a", row);
      var vm = this;
      var config = {
        loading: true,
        width: 500,
        render: function render(h) {
          return h("div", [h("div", {
            style: {
              display: "flex",
              justifyContent: "space-between"
            }
          }, [h("h3", {
            style: {
              width: "100%",
              paddingBottom: "5px"
            }
          }, _this8.$t("dictmenu.editiverterdict")), h("icon", {
            props: {
              type: "md-close",
              size: "16"
            },
            style: {
              cursor: "pointer"
            },
            on: {
              click: function click(evt) {
                vm.$Modal.remove();
              }
            }
          })]), h("Divider", {
            style: {
              margin: "8px 0"
            }
          }), h(addCom, {
            ref: "addCom",
            props: {
              edit: true,
              $store: vm.$store,
              _vm: vm,
              setData: row,
              product_type_codeData: vm.product_type_codeData,
              xieyi_codeData: vm.xieyi_codeData
            }
          })]);
        },
        onOk: function onOk() {
          var _this = this;

          var obj = this.$refs.addCom;
          obj.checkForm().then(function (res) {
            if (res) {
              //let { area_name, desc, area_code } = obj.formModel
              dict_update(obj.formModel).then(function (res) {
                var msg = res.errorMsg;

                if (res.result === 0) {
                  var _msg5 = res.errorMsg;
                  vm.$Message.success(_msg5);
                  vm.$Modal.remove();
                  vm.init();
                } else {
                  vm.$Message.error(msg);
                  _this.buttonLoading = false;
                }
              });
            } else {
              _this.buttonLoading = false;
            }
          });
        }
      };
      this.$Modal.confirm(config);
    },
    set_default: function set_default(row) {
      // console.log(row)
      var vm = this;
      this.$Modal.confirm({
        title: "设为默认",
        content: "您确定要设置" + row.protocol_name + "为默认吗？",
        loading: true,
        onOk: function onOk() {
          var _this = this;

          _set_default({
            dict_code: row.dict_code
          }).then(function (res) {
            var msg = res.errorMsg;

            if (res.result === 0) {
              var _msg6 = res.errorMsg;
              vm.$Message.success(_msg6);
              vm.$Modal.remove();
              vm.init();
            } else {
              vm.$Message.error(msg);
              _this.buttonLoading = false;
            }
          });
        }
      });
    },
    init: function init() {
      var _this9 = this;

      var userinfo = this.getUser();
      this.pass_priv = userinfo.pass_priv;
      this.get_type();
      this.tableLoading = true;
      product_list(_objectSpread({}, this.reqBase)).then(function (res) {
        _this9.tableLoading = false;
        _this9.tableDataList = [];

        if (res.result === 0) {
          _this9.tableDataList = res.body.list || [];
          _this9.getPageTotal = res.body.total;
        } else {
          _this9.tableDataList = [];
          _this9.getPageTotal = 0;

          _this9.$Message.error(res.errorMsg);
        }
      });
    },
    search: function search() {
      this.onSearch(this.form_filter);
    },
    reset: function reset() {
      this.form_filter = {
        xieyi_type: null,
        product_type_code: null,
        project_code: null
      };
      this.search();
    }
  },
  mounted: function mounted() {
    if (this.code) {
      this.$set(this.reqBase, "project_code", this.code);
    }

    if (this.reducehe) {
      this.reduceheight = this.reducehe;
    } else {
      this.init();
    }
  },
  created: function created() {// this.getPageSizeToStorage();
  }
};